import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CustomService {
  apiUrl = environment.url;

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  getCustomMaterialList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/CustomMaterial/GetCustomMaterialList`, payload);
  }

  getAllCustomMaterialList() {
    return this.http.get<any>(`${this.apiUrl}/CustomMaterial/GetAllCustomMaterialList`);
  }

  getCustomMaterialListForAdmin(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/AdminCustomMaterial/GetCustomMaterialList`, payload);
  }

  getAllCustomMaterialListForAdmin() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomMaterial/GetAll`);
  }

  getCustomConversionList() {
    return this.http.get<any>(`${this.apiUrl}/CustomConversion/GetAllCustomConversionList`);
  }

  getCustomConversionListForAdmin(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomConversion/GetCustomConversionList`,
      payload
    );
  }

  getAllCustomConversionListForAdmin() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomConversion/GetAll`);
  }

  GetCustomTruckList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/CustomTruck/GetCustomTruckList`, payload);
  }

  GetAllCustomTruckList() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomTruck/GetAllCustomTruckList`);
  }

  getAllCustomTruckList() {
    return this.http.get<any>(`${this.apiUrl}/CustomTruck/GetAllCustomTruckList`);
  }

  getAllAdminCustomTruckList() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomTruck/GetAllCustomTruckList`);
  }

  GetCustomTruckListForAdmin(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/AdminCustomTruck/GetCustomTruckList`, payload);
  }

  getCustomReuseList() {
    return this.http.get<any>(`${this.apiUrl}/CustomReuse/GetAllCustomReuseList`);
  }

  getCustomReuseListForAdmin(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/AdminCustomReuse/GetCustomReuseList`, payload);
  }

  getAllAdminCustomReuseList() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomReuse/GetAllCustomReuseList`);
  }

  getMateriallist(customMaterialId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomMaterial/GetCustomMaterialData?customMaterialId=${customMaterialId}`
    );
  }
  getMateriallistForAdmin(customMaterialId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomMaterial/GetCustomMaterialData?customMaterialId=${customMaterialId}`
    );
  }

  getCustomStorageList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/CustomStorage/GetCustomStorageList`, payload);
  }

  getAllCustomStorageList() {
    return this.http.get<any>(`${this.apiUrl}/CustomStorage/GetAllCustomStorageList`);
  }

  getCustomStorageListForAdmin(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/AdminCustomStorage/GetCustomStorageList`, payload);
  }

  getAllCustomStorageListForAdmin() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomStorage/GetAllCustomStorageList`);
  }

  getCustomFillingList() {
    return this.http.get<any>(`${this.apiUrl}/CustomFilling/GetAllCustomFillingList`);
  }

  getCustomFillingListForAdmin(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/AdminCustomFilling/GetCustomFillingList`, payload);
  }

  getAllCustomFillingListForAdmin() {
    return this.http.get<any>(`${this.apiUrl}/AdminCustomFilling/GetAll`);
  }

  getCustomTransportList(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomTransportScenario/GetCustomTransportScenarioList`,
      payload
    );
  }

  getAllCustomTransportList() {
    return this.http.get<any>(
      `${this.apiUrl}/CustomTransportScenario/GetAllCustomTransportScenarioList`
    );
  }

  getAllAdminCustomTransportScenarioList() {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomTransportScenario/GetAllCustomTransportScenarioList`
    );
  }

  getCustomTransportListForAdmin(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomTransportScenario/GetCustomTransportScenarioList`,
      payload
    );
  }

  getCustomWasteList(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomWasteScenario/GetCustomWasteScenarioList`,
      payload
    );
  }

  getCustomWasteListForAdmin(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomWasteScenario/GetCustomWasteScenarioList`,
      payload
    );
  }
  //new API of code refactor
  getAllCustomWasteScenarioList() {
    return this.http.get<any>(`${this.apiUrl}/CustomWasteScenario/GetAllCustomWasteScenarioList`);
  }

  getAllCustomWasteListForAdmin() {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomWasteScenario/GetAllCustomWasteScenarioList`
    );
  }

  deleteCustomData(id: number, customType: any) {
    return this.http.delete<any>(`${this.apiUrl}${customType}?id=${id}`);
  }

  copyCustomData(payload: any, customType: any) {
    return this.http.post<any>(`${this.apiUrl}${customType}`, payload);
  }

  getConversionlist(customConversionId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomConversion/GetCustomConversionData?customConversionId=${customConversionId}`
    );
  }

  getConversionlistForAdmin(customConversionId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomConversion/GetCustomConversionData?customConversionId=${customConversionId}`
    );
  }

  //New Custom Material modal APIs
  getPackageCostCalculationCustomMaterial(weight: any, cost: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomMaterial/GetPackageCostCalculationCustomMaterial?cost=${cost}&weight=${weight}`
    );
  }

  getPackageCostCalculationManufacture(amount: any, cost: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomMaterial/GetPackageCostCalculationManufacture?cost=${cost}&amount=${amount}`
    );
  }

  GetPackageCostCalculationCustomConversion(amount: any, cost: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomConversion/GetPackageCostCalculationCustomConversion?cost=${cost}&amount=${amount}`
    );
  }

  GetPackageCostCalculationCustomFilling(amount: any, cost: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomFilling/GetPackageCostCalculationCustomFilling?cost=${cost}&amount=${amount}`
    );
  }

  addCustomMaterial(customMaterialData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomMaterial/AddUpdateCustomMaterial`,
      customMaterialData
    );
  }

  addCustomMaterialForAdmin(customMaterialData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomMaterial/AddUpdateCustomMaterial`,
      customMaterialData
    );
  }

  addCustomConversion(customConversionData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomConversion/AddUpdateCustomConversion`,
      customConversionData
    );
  }
  addCustomConversionForAdmin(customConversionData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomConversion/AddUpdateCustomConversion`,
      customConversionData
    );
  }

  addCustomFilling(customMaterialData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomFilling/AddUpdateCustomFilling`,
      customMaterialData
    );
  }

  addCustomFillingForAdmin(customMaterialData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomFilling/AddUpdateCustomFilling`,
      customMaterialData
    );
  }

  getFillinglist(customFillingId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomFilling/GetCustomFillingData?customFillingId=${customFillingId}&isView=false`
    );
  }

  getFillinglistForAdmin(customFillingId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomFilling/GetCustomFillingData?customFillingId=${customFillingId}&isView=false`
    );
  }

  addCustomStorage(customStorageData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomStorage/AddUpdateCustomStorage`,
      customStorageData
    );
  }

  addCustomStorageForAdmin(customStorageData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomStorage/AddUpdateCustomStorage`,
      customStorageData
    );
  }

  getAddEditTrucklist(customTruckId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/CustomTruck/GetCustomTruckForAddUpdate?id=${customTruckId}`)
      .toPromise();
  }

  getAddEditTrucklistForAdmin(customTruckId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/AdminCustomTruck/GetCustomTruckForAddUpdate?id=${customTruckId}`)
      .toPromise();
  }

  addEditCustomTruck(customTruckData: any) {
    return this.http.post<any>(`${this.apiUrl}/CustomTruck/AddUpdateCustomTruck`, customTruckData);
  }

  addEditCustomTruckForAdmin(customTruckData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomTruck/AddUpdateCustomTruck`,
      customTruckData
    );
  }

  truckPackageLoadCalculation(tareMass: any, maxLoad: any, loadInTruck: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomTruck/GetTruckPackageLoadAndLoadingData?tareMass=${tareMass}&maxLoad=${maxLoad}&loadInTruck=${loadInTruck}`
    );
  }

  getAddEditTransportScenarioList(customTransportScenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomTransportScenario/GetCustomTransportScenarioForAddUpdate?id=${customTransportScenarioId}`
    );
  }

  getAddEditTransportScenarioListForAdmin(customTransportScenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomTransportScenario/GetCustomTransportScenarioForAddUpdate?id=${customTransportScenarioId}`
    );
  }

  getStorage(customStorageId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomStorage/GetCustomStorageForAddUpdate?id=${customStorageId}`
    );
  }

  getStorageForAdmin(customStorageId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomStorage/GetCustomStorageForAddUpdate?id=${customStorageId}`
    );
  }

  GetPackageCostCalculationCustomStorage(amount: any, cost: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomStorage/GetCostPerPackageDataCalculation?cost=${cost}&amount=${amount}`
    );
  }

  addCustomWasteScenario(customWasteScenarioData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomWasteScenario/AddUpdateCustomWasteScenario`,
      customWasteScenarioData
    );
  }

  addCustomWasteScenarioForAdmin(customWasteScenarioData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomWasteScenario/AddUpdateCustomWasteScenario`,
      customWasteScenarioData
    );
  }

  getWasteScenario(customWasteScenarioId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/CustomWasteScenario/GetCustomWasteScenarioForAddUpdate?id=${customWasteScenarioId}`
      )
      .toPromise();
  }

  getWasteScenarioForAdmin(customWasteScenarioId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/AdminCustomWasteScenario/GetCustomWasteScenarioForAddUpdate?id=${customWasteScenarioId}`
      )
      .toPromise();
  }

  GetTotalPercentageCustomWasteScenario(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomWasteScenario/GetTotalPercentageCalculation`,
      payload
    );
  }

  getCustomWasteDefaultValues(countryId: any, materialId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomWasteScenario/GetCustomWasteDefaultValues?countryId=${countryId}&&materialId=${materialId}`
    );
  }
  getReuseList(Id: any) {
    return this.http.get<any>(`${this.apiUrl}/CustomReuse/GetCustomReuseForAddUpdate?id=${Id}`);
  }
  getReuseListForAdmin(Id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AdminCustomReuse/GetCustomReuseForAddUpdate?id=${Id}`
    );
  }

  GetPackageCostCalculationCustomReuse(amount: any, cost: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomReuse/GetCostPerPackageDataCalculation?amount=${amount}&CostPerUnit=${cost}`
    );
  }

  addCustomReuse(customReuseData: any) {
    return this.http.post<any>(`${this.apiUrl}/CustomReuse/AddUpdateCustomReuse`, customReuseData);
  }

  addCustomReuseForAdmin(customReuseData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomReuse/AddUpdateCustomReuse`,
      customReuseData
    );
  }

  addEditTransportScenario(customTransportScenarioData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomTransportScenario/AddUpdateCustomTransportScenario`,
      customTransportScenarioData
    );
  }

  addEditTransportScenarioForAdmin(customTransportScenarioData: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AdminCustomTransportScenario/AddUpdateCustomTransportScenario`,
      customTransportScenarioData
    );
  }

  customInlineEdit(payload: [], module: any) {
    return this.http.post<any>(`${this.apiUrl}/${module}/InLineEdit`, payload);
  }

  getSeaDistanceForTransport(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomTransportScenario/CalculateSeaDistance?CustomTransoportScenarioDetails`,
      payload
    );
  }

  getSeaDistanceForTransportAsync(payload: any) {
    return this.http
      .post<any>(
        `${this.apiUrl}/CustomTransportScenario/CalculateSeaDistance?CustomTransoportScenarioDetails`,
        payload
      )
      .toPromise();
  }

  getCustomTruckListOfCurrentOrganization() {
    return this.http.get<any>(
      `${this.apiUrl}/Storage/GetCustomTrucks?organizationId=` +
        this.cookieService.get('organizationId')
    );
  }

  updatePreviewReportSettings(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/OrganizationReportSetting/AddUpdateCustomProjectReportSetting`,
      payload
    );
  }

  updateCustomReportSettings(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/OrganizationReportSetting/AddUpdateOrganizationReportSetting`,
      payload
    );
  }
}
